import { createRoot } from 'react-dom/client';

import { App } from './App';

import './styles/d1.css';
import './styles/app.css';

createRoot(document.getElementById('root')!).render(<App />);
